import {Col, Row} from "antd";
import {Field} from "react-final-form";
import {
  RenderFloatField,
  RenderRadioGroup,
  RenderSelectField,
  RenderTextArea
} from "../render-form-fields/RenderFormFields";
import React from "react";

export const customQuestionInputTypes = {
  TEXT: 'text',
  BOOLEAN: 'boolean',
  NOTICE_PERIOD: 'noticePeriod',
  CURRENT_ANNUAL_SALARY: 'currentAnnualSalary',
  EXPECTED_ANNUAL_SALARY: 'expectedAnnualSalary',
  INTEREST: 'interest',
}

export function CustomQuestionField({ name, question, getSectionCount, submittedOnce, isSubmitAllowed, jobInfo, formErrors }) {
  if (question.inputType === customQuestionInputTypes.INTEREST) {
    return null;
  }
  return (
    <Row className="job-interest-form__row job-interest-form__custom-question">
      <Col span={24}>
        <div className="job-interest-form__question__heading">
          {`${getSectionCount()}. ${question.questionText}`}
        </div>
        <Field name={`${name}.answer`}>
          {({ input, meta }) => {
            if (question.inputType === customQuestionInputTypes.TEXT) {
              return (
                <RenderTextArea
                  rows={2}
                  meta={meta}
                  errorText={submittedOnce && formErrors.customQuestionAnswerJson}
                  input={input}
                  disabled={!isSubmitAllowed}
                  placeholder="Enter Answer"
                />
              );
            }
            if (question.inputType === customQuestionInputTypes.BOOLEAN) {
              return (
                <RenderRadioGroup
                  meta={meta}
                  input={input}
                  isVertical={false}
                  errorText={submittedOnce && formErrors.customQuestionAnswerJson}
                  disabled={!isSubmitAllowed}
                  radioItems={[
                    {
                      label: 'Yes',
                      key: 'yes',
                    },
                    {
                      label: 'No',
                      key: 'no',
                    },
                  ]}
                  labelKey="label"
                  valueKey="key"
                />
              );
            }
            if (question.inputType === customQuestionInputTypes.NOTICE_PERIOD) {
              return (
                <RenderSelectField
                  className={'job-interest-form__custom-question__notice-period'}
                  selectOptions={[
                    { label: 'Immediate Joining', value: 0 },
                    { label: '1 week', value: 1 },
                    ...[2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((week) => ({
                      label: `${week} weeks`,
                      value: week,
                    })),
                  ]}
                  meta={meta}
                  errorText={submittedOnce && formErrors.customQuestionAnswerJson}
                  input={input}
                  disabled={!isSubmitAllowed}
                />
              );
            }
            if ([customQuestionInputTypes.CURRENT_ANNUAL_SALARY, customQuestionInputTypes.EXPECTED_ANNUAL_SALARY].includes(question.inputType)) {
              return (
                <div className="job-interest-form__custom-question__salary">
                  <RenderFloatField
                    input={input}
                    meta={meta}
                    precision={0}
                    max={999999999}
                    disabled={!isSubmitAllowed}
                    errorText={submittedOnce && formErrors.customQuestionAnswerJson}
                  />
                  <div>{jobInfo?.country?.currency}</div>
                </div>
              );
            }
            return null;
          }}
        </Field>
      </Col>
    </Row>
  )
}